import { render, staticRenderFns } from "./ResultsAccordionHeading.vue?vue&type=template&id=8d1d25b8&scoped=true&"
import script from "./ResultsAccordionHeading.vue?vue&type=script&lang=js&"
export * from "./ResultsAccordionHeading.vue?vue&type=script&lang=js&"
import style0 from "./ResultsAccordionHeading.vue?vue&type=style&index=0&id=8d1d25b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1d25b8",
  null
  
)

export default component.exports